module.exports = {
  id: 'newsletterForm',
  method: 'post',
  target: '_blank',
  action: 'https://eu2.cleverreach.com/f/146712-146368/wcs/',
  cells: [
    {
      fieldType: 'input',
      name: 'sprache',
      type: 'hidden',
      label: 'sprache',
      value: 'Englisch',
      hidden: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'Mail',
      placeholder: 'Mail',
      required: true
    },
    {
      fieldType: 'checkbox',
      name: 'rights',
      label: 'I’d like to receive Futurium’s email newsletter',
      required: true
    },
    {
      fieldType: 'infoText',
      copy:
        '<p>By subscribing to our newsletter you agree to our <a href="/en/privacy-protection" target="_blank">privacy policy</a> to receive email from us. You can unsubscribe at any time using the link in our welcome email, or any of our newsletters.</p>'
    }
  ],
  submitText: 'Submit'
};
